import bootstrap, { fontSizes } from '@theme-ui/preset-bootstrap';
import merge from 'lodash.merge';
import colors from './colors';
import styles from './styles';

const theme = merge({}, bootstrap, {
  initialColorMode: `light`,
  colors,
  fonts: {
    body: `"Open Sans", sans-serif`,
    heading: `inherit`,
  },
  fontWeights: { body: 400, heading: 300, medium: 500 },
  styles,
  shadows: {
    small: '0 0 5px 0 rgba(0, 0, 0, 0.1)',
    medium: '0 0 10px 0 rgba(0, 0, 0, 0.1)',
    large: '0 0.5rem 1rem rgba(0, 0, 0, 0.05)',
  },
  buttons: {
    primary: {
      color: 'onPrimary',
      backgroundColor: 'primary',
      borderColor: 'secondary',
      ':hover': {
        color: 'onSecondary',
        backgroundColor: 'secondary',
        textDecoration: 'none',
      },
    },
    secondary: {
      color: 'onSecondary',
      backgroundColor: 'secondary',
      ':hover': {
        textDecoration: 'none',
      },
    },
    light: {
      backgroundColor: 'white',
      color: 'text',
      borderColor: 'secondary',
      ':hover': {
        backgroundColor: 'secondary',
        color: 'onSecondary',
        textDecoration: 'none',
      },
      active: {
        backgroundColor: 'secondary',
        color: 'onSecondary',
        borderColor: 'secondary',
      },
    },
    text: {
      backgroundColor: 'transparent',
      border: 'none',
      color: 'text',
      ':hover': {
        color: 'secondary',
        textDecoration: 'none',
      },
    },
    muted: {
      backgroundColor: 'muted',
      color: 'text',
      ':hover': {
        backgroundColor: 'white',
        borderColor: 'muted',
        color: 'text',
      },
    },
  },
});

export default theme;
